<template>
    <div id="installedPrinters">
        <label for="installedPrinterName"><strong>Lista stampanti </strong>
            <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
        </label>
        <select  class="form-control" name="printer" id="printer" v-model="selected_printer">
            <!--<option disabled n-bind:key="undefined">Seleziona stampante</option>-->
            <option v-for="(printer,index) in printer_list" :key="index">{{ printer }}</option>
        </select>
    </div>
</template>
<script>
export default {
    name: "Printers",
    props: ['printer_list','spinner','Id'],
    data: function () {        
        return {
            selected_printer: this.Id
        }
    },
    watch: {
        selected_printer(value) {
            this.$emit('change', value);
        }
    },
    created()
    {
        //console.log(this.Id)
    }
}
</script>